import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from "src/environments/environment";

export interface PhoneBadgeEntry {
  id: number;
  phone_number: string;
  badge_color: string;
}

@Injectable({
  providedIn: 'root'
})
export class PhoneNumbersService {

  private apiUrl = `${environment.apiUri}/phone-numbers`; 

  constructor(private http: HttpClient) {}

  getPhoneBadgeColors(): Observable<PhoneBadgeEntry[]> {
    return this.http.get<PhoneBadgeEntry[]>(this.apiUrl);
  }

  addPhoneBadge(phone_number: string, badge_color: string): Observable<any> {
    return this.http.post(this.apiUrl, { phone_number, badge_color });
  }
}
